import { useState } from "react";
import { Package } from "lucide-react";
import NophoneCompose from "./NophoneCompose";
import Image from "next/image";

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* HEADER */}
      <header className="bg-gradient-primary sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            {/* <div className="w-16 h-16 bg-primary-foreground flex items-center justify-center shadow-lg"> */}
              {/* <Package className="w-7 h-7 text-primary" /> */}
              <Image
                width={60}
                height={60}
                src={"/mainLogo.avif"}
                alt=""
                objectFit={"cover"}
                className="rounded-full"
              />
            {/* </div> */}
            <span className="text-primary-foreground text-xl font-bold tracking-tight">
              Eagle cargo
            </span>
          </div>

          <nav className="md:flex items-center gap-8">
            {/* 🔵 POPUP OPEN BUTTON */}
            <button
              onClick={() => setOpen(true)}
              className="text-primary-foreground/90 text-sm hover:text-primary-foreground transition-colors font-bold"
            >
              Дугааргүй ачаа шалгах
            </button>

            <nav className="hidden md:flex items-center gap-8">
              <a
                href="#services"
                className="text-primary-foreground/90 text-sm hover:text-primary-foreground transition-colors font-bold"
              >
                Үйлчилгээ
              </a>
              <a
                href="#calculator"
                className="text-primary-foreground/90 text-sm hover:text-primary-foreground transition-colors font-bold"
              >
                Тооцоолуур
              </a>
              <a
                href="#contact"
                className="text-primary-foreground/90  text-sm hover:text-primary-foreground transition-colors font-bold"
              >
                Холбоо барих
              </a>
            </nav>
          </nav>
        </div>
      </header>

      {/* POPUP COMPONENT */}
      <NophoneCompose open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default Header;
